<template>
  <div v-if="publishStatement" class="app-alert">
    <ElAlert :type="alertType" class="app-alert" :closable="false">
      <div slot="title" class="app-alert__title">
        <i class="el-icon-warning" />
        <span>{{ publishStatement.header }}</span>
      </div>

      <span
        v-dompurify-html="normalizedAlertContent"
        class="app-alert__content"
      />
    </ElAlert>
  </div>
</template>

<script>
import { APP_DETAILS } from '@/store/types';
import { mapGetters } from 'vuex';

export default {
  name: 'AppAlert',

  computed: {
    ...mapGetters({ app: APP_DETAILS }),

    publishStatement() {
      return this.app.publishStatement;
    },
    normalizedAlertContent() {
      return this.publishStatement?.reason.replace('<p>&nbsp;</p>', '');
    },
    alertType() {
      const importantTypes = ['update_rejected', 'rejected', 'remove'];
      return importantTypes.includes(this.publishStatement.type)
        ? 'error'
        : 'warning';
    },
  },
};
</script>

<style lang="scss">
.app-alert {
  margin-bottom: $global-margin * 2;

  &__title {
    margin-bottom: $global-margin;
    font-size: 1rem;
  }

  &__content {
    color: $lb-medium-black;
  }

  a {
    color: $lb-link-color;

    &:hover {
      color: $lb-link-hovered-color;
    }
  }
}
</style>
